import {
  Component,
  OnInit,
  AfterViewInit,
  LOCALE_ID,
  PLATFORM_ID,
  Inject
} from "@angular/core";
import { FacadeService } from "../../service/facade.service";
import { SEO } from "../../../app/models/seo/seoInterface";
import { seoManagement } from "../../../app/models/seo/seoClass";
import { Title, Meta } from "@angular/platform-browser";
import { LinkService } from "../../../app/service/link.service";
import { isPlatformBrowser } from "@angular/common";
import { Content } from "@angular/compiler/src/render3/r3_ast";

@Component({
  selector: "app-about-us",
  templateUrl: "./about-us.component.html",
  styleUrls: ["./about-us.component.scss"]
})
export class AboutUsComponent extends seoManagement
  implements OnInit, SEO, AfterViewInit {
  afterLoad: Boolean = false;
  title: string;
  img;
  image: string;
  aboutUsData;
  description: string;
  url: string;
  constructor(
    public titleService: Title,
    public metaService: Meta,
    private _FacadeService: FacadeService,
    public link: LinkService,
    @Inject(LOCALE_ID) local,
    @Inject(PLATFORM_ID) private platfromId
  ) {
    super(
      titleService,
      metaService,
      isPlatformBrowser(platfromId),
      local,
      link
    );
    this.currentLangId = local;
  }

  ngOnInit() {
    this._FacadeService.About.AboutUs.subscribe(res => {
      this.aboutUsData = res.data;
    });
  }

  ngAfterViewInit() {
    this.afterLoad = true;
  }

  setSeoTagsProperties() {
    if (this.currentLangId === "ar") {
      this.title = "نيو فرنتشر للاثاث المكتبي | افضل الخامات و اقل الاسعار";
      this.description =
        'بدأنا الإنتاج عام 2007 في مصنع ومعرض العاشر من رمضان ، ثم قمنا بتوسيعه حتى أطلقنا علامة تجارية "نيو فرنتشر للاثاث المكتبي".';
    } else {
      this.title = "New furniture Egypt | the best quality with least prices";
      this.description =
        "We started production 2007 at 10th of Ramadans factory and gallery then we expanded till we launched as New furniture brand. ";
    }
    this.url =
      "https://www.newfurniture-eg.com/" + this.currentLangId + "about-us/";
    this.link.addTag({
      rel: "",
      href: this.url
    });

    this.setSeoTags(this.title, this.description, this.image, this.url);
  }
}
